/**
 * WordPress dependencies
 */
import { SVG, Rect } from '@wordpress/primitives';

const queryPagination = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Rect x="4" y="10.5" width="6" height="3" rx="1.5" fill="#000" />
		<Rect x="12" y="10.5" width="3" height="3" rx="1.5" fill="#000" />
		<Rect x="17" y="10.5" width="3" height="3" rx="1.5" fill="#000" />
	</SVG>
);

export default queryPagination;
